/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_id: z.string().uuid(),
  construction_plan_area_id: z.string().uuid(),
  quality_measurement_item_id: z.number(),
  value: z.number().nullable(),
  judgment: z.string().nullable(),
  construction_action_id: z.string().uuid().nullable(),
  measured_at: z.number(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const QualityRecordBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type QualityRecordBase = z.infer<typeof base>;
export type QualityRecordBasePutPayload = z.infer<typeof put>;
export type QualityRecordBasePatchPayload = z.infer<typeof patch>;
export type QualityRecordBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type QualityRecordBaseCreateAttributes = z.infer<typeof create>;
export type QualityRecordBaseUpdateAttributes = z.infer<typeof update>;
export type QualityRecordBaseCacheAttributes = z.infer<typeof cache>;
export type QualityRecordBaseCachesAttributes = z.infer<typeof caches>;